var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSm = function SvgSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12c.522 0 12-1.566 12-1.566L24 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M16.763 8.28 12 13.045 7.237 8.281a5.706 5.706 0 0 0-.976 3.198v1.565a5.75 5.75 0 0 0 3.877 5.43c-.3.589-.25 1.324.191 1.875l1.706-1.367 1.705 1.367a1.736 1.736 0 0 0 .18-1.897 5.749 5.749 0 0 0 3.819-5.408V11.48c0-1.183-.36-2.284-.976-3.198Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 17.218a4.179 4.179 0 0 1-4.174-4.174v-1.566A4.179 4.179 0 0 1 12 7.306a4.179 4.179 0 0 1 4.174 4.174v1.565A4.179 4.179 0 0 1 12 17.218Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M14.609 13.043v-1.565A2.612 2.612 0 0 0 12 8.87a2.612 2.612 0 0 0-2.608 2.61v1.564l2.608.522 2.609-.522Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M9.392 13.043A2.612 2.612 0 0 0 12 15.652a2.612 2.612 0 0 0 2.609-2.609H9.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M15.13 7.304a1.565 1.565 0 0 0-2.609-1.166v-.921h.522V4.174h-.522v-.522h-1.043v.522h-.522v1.043h.522v.92A1.565 1.565 0 0 0 9.39 8.47v.92h5.217v-.92c.32-.286.522-.703.522-1.166Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSm;